export default "/images/cfa2bffcbefe82e8cc75343604a448da.avif";